export const contentTableConfig = {
  title: 'H5列表',
  propList: [
    { prop: 'title', label: '标题', minWidth: '80' },
    { prop: 'link', label: '访问链接', minWidth: '80', slotName: 'link' },
    { prop: 'type', label: '类型', minWidth: '80', slotName: 'type' },
    {
      prop: 'createdTime',
      label: '创建时间',
      minWidth: '80',
      slotName: 'createdTime'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
